import {Ability} from '~/lib/ability';

export class SourcesAbility extends Ability {
    canDelete = () => this.isAdmin();
    canEdit = () => this.isAdmin();
    canOnlyView = () => !!this.isSeller();
    canCreate = () => this.isAdmin();
}
